






















































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import NotificacoesService from "@/service/notificacoes/NotificacoesService";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { UploadModel } from "@/models/administracao/comunicacao/UploadModel";
import { extend } from 'vee-validate';
// @ts-ignore
import _ from 'lodash';

@Component({
  components: {
    GsModalDialog,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class Upload extends Vue {
  $refs!: {
    templateObserver: InstanceType<typeof ValidationObserver>;
    variaveisObserver: InstanceType<typeof ValidationObserver>;
    nomeTemplateField: Vue & { focus: () => void };
  };

  cabecalho= [
    { text: "Nome Template", value: "nome", sortable: true, width: "20%" },
    { text: "Tipo", value: "tipoComunicacao", sortable: true, width: "7%",},
    { text: "Assunto", value: "assunto", sortable: true, width: "20%" },
    { text: "Gatilho", value: "gatilho", sortable: true, width: "20%",},
    { text: "Tempo Disp.", value: "delayDisparoMinutos", sortable: true, width: "10%",},
    { text: "Ações", value: "actions", width: "25%" },
  ];

  templates: any[] = [];
  conteudoArquivo = null;
  conteudoMensagem: string | undefined = '';

  dialogType = "confirm";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  showDialogExcluir = false;
  showDialogAtivarDesativar = false;

  uploadDefault : UploadModel = { 
    nomeArquivo: undefined,
    assunto: undefined,
    gatilho: undefined,
    tipoComunicacao: undefined,
    conteudoArquivo: undefined,
    consulta: 'select 1 from dual',
    delayDisparoMinutos: '00:00',
  };

  upload = _.cloneDeep(this.uploadDefault);

  tiposComunicacao = [
    { valor: 'EMAIL', descricao: 'E-mail' },
    { valor: 'SMS', descricao: 'SMS' },
    { valor: 'PUSH', descricao: 'Push' }
  ];

  gatilhos : any[] = [ 
    { id: undefined, descricao: undefined } 
  ];
  templateExclusao = 0;
  habilitarCampoUpload = true;
  habilitarCampoMensagem = false;
  habilitarCampoAssunto = true;
  limiteMensagem = 1000;
  labelAssunto = "Assunto E-Mail";

  loading = false;
  sqlValido = true;
  arquivoObrigatorio = true;

  templateAtivo = {
    id: 0,
    ativo: true
  };

  // template de variáveis
  variaveisConfig ={
    parametrosConsulta: [],
    parametrosEntrada: []
  };

  valoresParametros = {
    parametrosConsulta: {},
    parametrosEntrada: {}
  };

  novoParametroConsulta = '';
  novoParametroEntrada = '';
  showDialogVariaveis = false;
  consultaVariaveisOK = false;
  templateAtualId = null as number | null;
  loadingDisparo = false;
  variaveisCarregadas = false;
  // template de variáveis

  mounted() {
     this.obterTemplantes();
     this.obterGatilhos();
     this.conteudoArquivo = null;
  }
  
  converterArquivo(arquivoSelecionado:any) {
    const file = Array.isArray(arquivoSelecionado) ? arquivoSelecionado[0] : arquivoSelecionado
    this.upload.conteudoArquivo = undefined;
    if (!file) return
    const reader = new FileReader()
    reader.onload = () => {
    if (reader.result) {
      const resultado = reader.result as string;  
      this.upload.conteudoArquivo = resultado.split(',')[1];  
      
    } else {
      console.error('reader.result veio nulo');
    }
    };

    reader.onerror = err => {
      console.error('Erro ao ler arquivo:', err)
    }

    reader.readAsDataURL(file)
  }

  converterTexto(texto:any) {
    this.upload.conteudoArquivo = undefined;
    if(texto) {
      this.upload.conteudoArquivo = btoa(unescape(encodeURIComponent(texto)));
    }
    
  } 

  @Watch("upload.tipoComunicacao")
  tipoComunicacao(val: any) {
    if (val == undefined) {
      return;
    }
    
    if(val.valor == "EMAIL") {
      this.habilitarCampoUpload = true;
      this.habilitarCampoMensagem = false;
      this.habilitarCampoAssunto = true;
      this.conteudoArquivo = null;
      this.conteudoMensagem = '';
      this.labelAssunto = "Assunto E-Mail";
    } else if (val.valor == "SMS") {
      this.habilitarCampoUpload = false;
      this.habilitarCampoMensagem = true;
      this.habilitarCampoAssunto = false;
      this.limiteMensagem = 150;
      this.conteudoArquivo = null;
      this.upload.assunto = '';
    } else if (val.valor == "PUSH") {
      this.habilitarCampoUpload = false;
      this.habilitarCampoMensagem = true;
      this.habilitarCampoAssunto = true;
      this.limiteMensagem = 1000;
      this.labelAssunto = "Assunto Push";
      this.conteudoArquivo = null;
    }
  }

  alterarConfiguracao(uploadModel: any) {
    const tipoComunicacao = this.tiposComunicacao.find(t => t.valor === uploadModel.tipoComunicacao);
    const gatilho = this.gatilhos.find(t => t.id === uploadModel.gatilho);
    this.upload = {
      nomeArquivo: uploadModel.nome,
      assunto: uploadModel.assunto,
      gatilho: gatilho,
      tipoComunicacao: tipoComunicacao,
      conteudoArquivo: undefined,
      consulta: uploadModel.variavel?.consulta ?? undefined,
      delayDisparoMinutos: uploadModel.delayDisparoMinutos,
    };

    if (uploadModel.tipoComunicacao == "EMAIL") {
      this.conteudoArquivo = null;
    } else {
      this.conteudoMensagem = uploadModel.conteudo ;
    }
    this.arquivoObrigatorio = false;

     this.$nextTick(() => {
    const input = this.$refs.nomeTemplateField as Vue & { focus: () => void };
    if (input && input.focus) {
      input.focus();
    }
  });
  }

  obterTemplantes() {
    this.loading = true;
    this.templates = [];
    NotificacoesService
      .listarTemplates()
      .then((res: any[]) => {
        this.templates = (res as any).data.sort((a: any, b: any) => {
          const gatilhoA = (a.gatilho || '').toLowerCase().trim();
          const gatilhoB = (b.gatilho || '').toLowerCase().trim();
          const tipoA = (a.tipoComunicacao || '').toLowerCase().trim();
          const tipoB = (b.tipoComunicacao || '').toLowerCase().trim();

          if (gatilhoA < gatilhoB) return -1;
          if (gatilhoA > gatilhoB) return 1;
          if (tipoA < tipoB) return -1;
          if (tipoA > tipoB) return 1;
          return 0;
        });
        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  }

  obterGatilhos() {
    this.loading = true;
    this.gatilhos = [];
    NotificacoesService
      .listarGatilhos()
      .then((res: any[]) => {
        this.gatilhos = (res as any).data.sort((a: any, b: any) => {
          if (a.descricao < b.descricao) return -1;
          if (a.descricao > b.descricao) return 1;
          return 0;
        });
        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  }

  async validarSql() {
    if (!this.upload.consulta) {
      this.sqlValido = true;
      return true;
    }
    NotificacoesService
      .validarSql(this.upload.consulta || "").then((res: any) => {
        this.sqlValido = res.data;
        if (!this.sqlValido ) {
          this.openDialog("error", "Template" , "Variavel inválida. Confira sua consulta.");
          return;
        }
      })
      .catch((err) => {
        this.loading = false;
        this.openDialog("error", "Template" , "Erro ao validar variavel"); 
        console.log(err);
      });
  }

  cancelar() {
    this.limpar();
  }

  salvar() {   
    if (!this.sqlValido ) {
      this.openDialog("error", "Template" , "Variavel inválida. Confira sua consulta.");
      return;
    } 
    this.$refs.templateObserver.validate().then((valid) => {
      if (valid) {
        this.loading = true;
        this.gatilhos = [];
        NotificacoesService
        .salvarTemplate(this.upload).then((res: any[]) => {
            this.obterTemplantes();  
            this.openDialog("success", "Template" , "Templante salvo com sucesso"); 
            this.arquivoObrigatorio = true;
            this.limpar();
          })
          .catch((err) => {
            this.loading = false;
            this.openDialog("error", "Template" , "Erro ao salvar template"); 
            console.log(err);
          });
        this.loading = false;  
      }  
    });  
  }

  // template de variáveis
  abrirDialogVariaveis(template?: any) {
    this.consultaVariaveisOK = false;
    this.templateAtualId = template.id;

    this.valoresParametros = {
        parametrosConsulta: {},
        parametrosEntrada: {}
    };

    NotificacoesService
    .recuperarConfiguracaoVariaveis(template.id)
    .then((res: any) => {
      this.variaveisConfig = JSON.parse(JSON.stringify(res.data));
      
      // Inicializa parametrosConsulta (mesmo se vier vazio)
      this.variaveisConfig.parametrosConsulta = this.variaveisConfig.parametrosConsulta || [];
      
      // Inicializa parametrosEntrada (mesmo se vier vazio)
      this.variaveisConfig.parametrosEntrada = this.variaveisConfig.parametrosEntrada || [];
      
      // Cria as propriedades para cada parâmetro de consulta
      this.variaveisConfig.parametrosConsulta.forEach(param => {
        this.$set(this.valoresParametros.parametrosConsulta, param, '');
      });
      
      // Cria as propriedades para cada parâmetro de entrada (mesmo que o array esteja vazio)
      this.variaveisConfig.parametrosEntrada.forEach(param => {
        this.$set(this.valoresParametros.parametrosEntrada, param, '');
      });

      // Se não houver parâmetros de entrada, considera que a consulta já está OK
      if (this.variaveisConfig.parametrosEntrada.length === 0) {
        this.consultaVariaveisOK = true;
      }

      this.loading = false;
      this.showDialogVariaveis = true;
    })
    .catch((err) => {
      this.loading = false;
      this.openDialog("info", "Verifique as informações", err.message);
      console.log(err);
    });
  }

  fecharDialogVariaveis() {
    this.showDialogVariaveis = false;
  }

  formatarParametros(parametros: any): any {
    const result: any = {};
    
    for (const [key, value] of Object.entries(parametros)) {
      // Converte para número se a chave contém 'id' e o valor é uma string numérica
      if (key.toLowerCase().includes('id') && typeof value === 'string' && !isNaN(Number(value))) {
        result[key] = Number(value);
      } else {
        result[key] = value;
      }
    }
    
    return result;
  }

  carregarVariaveis() {
    this.valoresParametros.parametrosEntrada = {};
    this.consultaVariaveisOK = false;
    this.variaveisCarregadas = false;

    if (!this.templateAtualId) {
      this.openDialog("error", "Erro", "ID do template não identificado");
      return;
    }

    const parametrosFormatados = this.formatarParametros(this.valoresParametros.parametrosConsulta);
    const payload = {
      idTemplate: this.templateAtualId, // Você pode tornar isso dinâmico se necessário
      parametros: parametrosFormatados
    };

    NotificacoesService
    .executarConsultar(payload)
    .then((res: any) => {
      if (res.data) {
        this.preencherParametrosEntrada(res.data);
        this.consultaVariaveisOK = true;
        this.variaveisCarregadas = true;
      }
      this.loading = false;      
    })
    .catch((err) => {
      this.loading = false;
      this.consultaVariaveisOK = false;
      this.variaveisCarregadas = false;
      this.openDialog("info", "Verifique as informações", err.message);
      console.log(err);
    });
  }

  preencherParametrosEntrada(dadosRetorno: any) {
    // Para cada parâmetro de entrada configurado
    this.variaveisConfig.parametrosEntrada.forEach(param => {
      // Verifica se o parâmetro existe nos dados retornados
      if (dadosRetorno.hasOwnProperty(param)) {
        // Atribui o valor correspondente
        this.$set(this.valoresParametros.parametrosEntrada, param, dadosRetorno[param]);
      }
    });
  }

  async todosCamposPreenchidos() {
      if (!this.consultaVariaveisOK) return false;
      
      // Se não há parâmetros de entrada, considera válido
      if (this.variaveisConfig.parametrosEntrada.length === 0) {
        return true;
      }
      
      // Verifica se todos os campos obrigatórios estão preenchidos
      const observer = this.$refs.variaveisObserver as InstanceType<typeof ValidationObserver>;
      if (observer) {
        const isValid = await observer.validate();
        return isValid;
      }
      return false;
  }

  async efetuarDisparo() {
    try {
      this.loadingDisparo = true;

      if (!this.variaveisCarregadas) {
        this.openDialog("error", "Erro", "Carregue as variáveis primeiro");
        return;
      }
      const isValid = await this.todosCamposPreenchidos();
      if (!isValid) {
        this.openDialog("info", "Informação", "Preencha todos os campos obrigatórios");
        return;
      }

      if (!this.templateAtualId) {
        this.openDialog("error", "Erro", "ID do template não identificado");
        return;
      }

      // Formata os parâmetros conforme necessário
      const parametrosFormatados: Record<string, any> = {};
      
      if (this.variaveisConfig.parametrosEntrada.length > 0) {
        for (const [key, value] of Object.entries(this.valoresParametros.parametrosEntrada)) {
          if (value !== undefined && value !== null && value !== '') {
            // Converte para número se a chave contém 'id' e o valor é numérico
            if (key.toLowerCase().includes('id') && !isNaN(Number(value))) {
              parametrosFormatados[key] = Number(value);
            } else {
              parametrosFormatados[key] = value;
            }
          }    
        }
      }

      // 1. Inclui primeiro os parâmetros de consulta
      for (const [key, value] of Object.entries(this.valoresParametros.parametrosConsulta)) {
          if (value !== undefined && value !== null && value !== '') {
              if (key.toLowerCase().includes('id') && !isNaN(Number(value))) {
                  parametrosFormatados[key] = Number(value);
              } else {
                  parametrosFormatados[key] = value;
              }
          }
      }

      // 2. Depois adiciona/sobrescreve com os parâmetros de entrada
      for (const [key, value] of Object.entries(this.valoresParametros.parametrosEntrada)) {
          if (value !== undefined && value !== null) {
              if (key.toLowerCase().includes('valor') && !isNaN(Number(value))) {
                  parametrosFormatados[key] = Number(value);
              } 
              else if (value === '') {
                  parametrosFormatados[key] = null;
              } else {
                  parametrosFormatados[key] = value;
              }
          }
      }
      // Monta o objeto no formato solicitado
      const payload = {
        idTemplate: this.templateAtualId,
        parametros: parametrosFormatados
      };

      await NotificacoesService.efetuarDisparo(payload);
        this.openDialog("success", "Sucesso", "Disparo realizado com sucesso");
        this.fecharDialogVariaveis();
    } catch (err) {
        console.error('Erro ao efetuar disparo:', err);
        const mensagem = (err as any).response?.data?.message || 'Ocorreu um erro ao tentar realizar o disparo';
        this.openDialog("error", "Erro", mensagem);
    } finally {
        this.loadingDisparo = false;
    }
  }

  consultaPreenchida() {
    // Verifica se todos os campos obrigatórios estão preenchidos
    return Object.keys(this.valoresParametros.parametrosConsulta).length > 0 && 
      Object.values(this.valoresParametros.parametrosConsulta).every(val => val !== undefined && val !== '');
  }
  // template de variáveis

  downloadTemplate(val:any) {
    NotificacoesService
    .downloadTemplate(val.id).then((res: any[]) => {
        let fileURL = window.URL.createObjectURL(new Blob([(res as any).data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        const nomeArquivo = val.nome.endsWith('.html') ? val.nome : val.nome + '.html'
        fileLink.setAttribute('download', nomeArquivo)
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  }

  excluirTemplateConfirmar(val:any) {
    this.templateExclusao = val.id;
    this.openDialogExcluir(
      "confirm",
      "Confimação de exclusão",
      `Deseja excluir o template ${val.nome} ?`
    )
  }

   ativarDesativarTemplateConfirmar(val: any) {
    if (val.ativo) {
      this.templateAtivo = {
        id: val.id,
        ativo: true
      };
      this.openDialogAtivarDesativar(
        "confirm",
        "Confimação de ativação",
        `Deseja ativar o template ${val.nome} ?`
      )
    } else {
       this.templateAtivo = {
          id: val.id,
          ativo: false
        };
       this.openDialogAtivarDesativar(
        "confirm",
        "Confimação de inativacão",
        `Deseja inativar o template ${val.nome} ?`
      )
    } 
  }

  ativarDesativarTemplate() {
    if (this.templateAtivo.ativo) {
      NotificacoesService
      .ativarTemplate(this.templateAtivo.id).then(() => {
        this.obterTemplantes();  
        this.openDialog("success", "Template" , "Templante ativado com sucesso"); 
        this.limpar();
      })
      .catch(() => {
        this.openDialog('error', 'Erro', 'Erro ao ativar template.');
      })
    } else {
      NotificacoesService
      .inativarTemplate(this.templateAtivo.id).then(() => {
        this.obterTemplantes();  
        this.openDialog("success", "Template" , "Templante inativado com sucesso"); 
        this.limpar();
      })
      .catch(() => {
        this.openDialog('error', 'Erro', 'Erro ao inativar template.');
      })
    } 
  }

  excluirTemplate() {
    NotificacoesService
    .excluirTemplate(this.templateExclusao).then(() => {
      this.obterTemplantes();  
      this.openDialog("success", "Template" , "Templante excluido com sucesso"); 
      this.limpar();
    })
    .catch(() => {
       this.openDialog('error', 'Erro', 'Erro ao realizar a exclusão do template.');
    })
  }

  limpar() {
    this.conteudoArquivo = null;
    this.conteudoMensagem = '';
    this.upload = _.cloneDeep(this.uploadDefault);
    
    this.obterGatilhos();
    this.$refs.templateObserver.reset();
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  private openDialogExcluir(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialogExcluir = true;
  }

   private openDialogAtivarDesativar(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialogAtivarDesativar = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
    this.showDialogExcluir = false;
    if (this.showDialogAtivarDesativar) {
      this.showDialogAtivarDesativar = false;
      this.obterTemplantes();
    }
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "error";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
extend('maxTime', {
  message: 'O tempo máximo permitido é 23:59',
  validate: value => {
    if (!/^\d{2}:\d{2}$/.test(value)) return false;

    const [hours, minutes] = value.split(':').map(Number);
    if (hours > 23 || minutes > 59) return false;

    return true;
  }
});
